import { render, staticRenderFns } from "./NormalSearchNav53.vue?vue&type=template&id=230da4aa&scoped=true&"
import script from "./NormalSearchNav53.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav53.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230da4aa",
  null
  
)

export default component.exports